import get from "lodash/get"
import { createRef, Component } from "react"
import { ReactSVG } from "react-svg"
import Button from "component-lib/Base/components/BaseButton/BaseButton"
import { CSSTransition, TransitionGroup } from "react-transition-group"
// eslint-disable-next-line react-19-upgrade/no-prop-types
import PropTypes from "prop-types"
import getContentUrl from "utils-lib/getContentUrl"
import { withLocalization } from "hoc-lib/localization"
import { KEY_CODE_MAPPING } from "constants-lib/keyCodes"
import "../../../SiteSearch/SiteSearch.scss"
import "./BottomHeader.scss"
import { getWindow } from "utils-lib/getWindow"
import { isTeamsitePage } from "utils-lib/isTeamsitePage"
import { isMyWMApp } from "utils-lib/isMyWMApp"
import { withLDConsumer } from "launchdarkly-react-client-sdk"
import AlgoliaSearch from "./components/AlgoliaSearch/AlgoliaSearch"
import MenuItem from "./components/MenuItem/MenuItem"
import { Link } from "../../../Base"
import NextImageWrapper from "../../../SSR/NextImageWrapper"
import {
  pushSearchClickData,
  pushExitClickData,
  pushExitOnBlurData,
} from "./analytics/analytics"

const ssrWindow = getWindow()

const strings = {
  en_CA: {
    SEARCH_PLACEHOLDER: `How can we help?`,
    SR_LOGO_TEXT: `Waste Management Home`,
  },

  fr_CA: {
    SEARCH_PLACEHOLDER: `Comment pouvons-nous vous aider?`,
    SR_LOGO_TEXT: `Waste Management Résidence`,
  },
}

class BottomHeader extends Component {
  constructor(props) {
    super(props)
    this.search = createRef()
    this.headerSearch = createRef()
    this.closeButtonWrapper = createRef()
    this.closeButton = createRef()

    this.state = {
      showSearch: false,
      hitEnterOnSearch: false,
    }
  }

  componentDidMount() {
    if (!isMyWMApp) {
      ssrWindow.document.addEventListener("keydown", this.handleEsc)
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.showSearch && !this.state.showSearch) {
      this.closeButtonWrapper.focus()
    } else if (!prevState.showSearch && this.state.showSearch) {
      // this.search.focus()
    }

    if (
      !isMyWMApp &&
      prevProps.location?.pathname !== this.props.location?.pathname
    ) {
      this.setState({
        showSearch: false,
      })
    }
  }

  componentWillUnmount() {
    if (!isMyWMApp) {
      ssrWindow.document.removeEventListener("keydown", this.handleEsc)
    }
  }

  handleEsc = (e) => {
    if (e.keyCode === KEY_CODE_MAPPING.ESCAPE) {
      this.setState({ showSearch: false })
      pushExitClickData()
    }
  }

  renderCloseButton() {
    return (
      <Button
        aria-haspopup="dialog"
        // eslint-disable-next-line no-return-assign
        ref={(ref) => (this.closeButtonWrapper = ref)}
        className="MegaNav__search MegaNav__search--main bg-transparent a-searchTaggable"
        style={{
          padding: `.25rem 0`,
        }}
        analytics="global-search-magnifying-glass-click"
        type="button"
        onClick={() => {
          this.setState({ showSearch: true })
          pushSearchClickData()
        }}
      >
        <span className="sr-only">Search</span>
        <NextImageWrapper
          wrapper="span"
          alt="search icon"
          src={getContentUrl("/content/dam/wm/icons/search-icon.svg")}
          nextImageProps={{
            height: 26.8,
            width: 20.8,
            loading: "eager",
          }}
          renderLegacyComponent={(props) => <ReactSVG {...props} />}
        />
      </Button>
    )
  }

  render() {
    const {
      navigationDetails,
      closeMegaNav,
      languageRoute,
      logo,
      logoLink,
      megaNavSelection,
      onMegaNavSelection,
      strings,
      indexList,
      suggestionIndex,
      queryIndex,
      filterType,
      searchBarPlaceholderText,
      numResults,

      numHighlightedResults,
      numberQueries,
      numCharacters,
      errorMessageTitle,
      errorMessageDescription,
      failureTitle,
      failureDescription,
      suggestedText,
      resultsText,
      seeAllResultsText,
      searchDelay,
      resultsIndex,
    } = this.props

    const { hitEnterOnSearch, showSearch } = this.state

    if (navigationDetails) {
      const isExternalLink =
        isMyWMApp || isTeamsitePage(ssrWindow.location.pathname)
      return (
        <div data-testid="BottomHeader">
          <div
            className="sub-header d-flex align-items-center"
            style={{
              height: 72,
            }}
          >
            <div className="container">
              <div className="row w-100">
                <div className="d-flex w-100 justify-content-between align-items-center">
                  <div
                    className="app-logo-container d-flex align-items-center"
                    style={{
                      alignItems: showSearch ? `flex-start` : `center`,
                      flexGrow: 1,
                    }}
                  >
                    <Link
                      className="app-logo position-relative"
                      href={`${logoLink}`}
                      isExternalLink={isExternalLink}
                      analytics_key="header logo"
                    >
                      <span className="sr-only">{strings.SR_LOGO_TEXT}</span>
                      <NextImageWrapper
                        wrapper="span"
                        alt=""
                        className="footer-logo"
                        src={getContentUrl(logo)}
                        style={{ height: `2.75rem`, width: `6.6875rem` }}
                        nextImageProps={{
                          height: 44,
                          width: 107,
                          loading: "eager",
                        }}
                        renderLegacyComponent={(props) => (
                          <ReactSVG {...props} />
                        )}
                      />
                    </Link>
                    <TransitionGroup className="todo-list">
                      {this.state.showSearch && (
                        <CSSTransition
                          timeout={300}
                          classNames="SiteSearch__overlay"
                        >
                          <div
                            className="position-absolute"
                            onClick={() => {
                              this.setState({
                                showSearch: false,
                              })
                              pushExitOnBlurData()
                            }}
                            style={{
                              background: `rgba(0, 0, 0, .5)`,
                              zIndex: -1,
                              top: 0,
                              left: 0,
                              height: `100vh`,
                              width: `100vw`,
                            }}
                          />
                        </CSSTransition>
                      )}
                    </TransitionGroup>
                    {showSearch ? (
                      <AlgoliaSearch
                        onClose={(e) => {
                          e.preventDefault()
                          this.setState(
                            {
                              showSearch: false,
                            },
                            () => {
                              pushExitClickData()
                              ssrWindow.document
                                ?.querySelector(
                                  `[analytics="global-search-magnifying-glass-click"]`,
                                )
                                ?.focus()
                            },
                          )
                        }}
                        indexList={indexList}
                        resultsIndex={resultsIndex}
                        suggestionIndex={suggestionIndex}
                        queryIndex={queryIndex}
                        filterType={filterType}
                        searchBarPlaceholderText={searchBarPlaceholderText}
                        numResults={numResults}
                        numHighlightedResults={numHighlightedResults}
                        numberQueries={numberQueries}
                        numCharacters={numCharacters}
                        errorMessageTitle={errorMessageTitle}
                        errorMessageDescription={errorMessageDescription}
                        failureTitle={failureTitle}
                        failureDescription={failureDescription}
                        suggestedText={suggestedText}
                        resultsText={resultsText}
                        seeAllResultsText={seeAllResultsText}
                        searchDelay={searchDelay}
                      />
                    ) : (
                      <nav className="navItems d-flex">
                        {navigationDetails.map((menuItem) => {
                          if (!menuItem) {
                            return null
                          }

                          return (
                            <MenuItem
                              {...menuItem}
                              closeMegaNav={closeMegaNav}
                              key={get(
                                menuItem,
                                `firstLevelNavigationText`,
                                ``,
                              )}
                              languageRoute={languageRoute}
                              megaNavSelection={megaNavSelection}
                              onMegaNavSelection={onMegaNavSelection}
                            />
                          )
                        })}
                      </nav>
                    )}
                  </div>
                  {showSearch ? null : (
                    <div
                      tabIndex="-1"
                      // eslint-disable-next-line no-return-assign
                      ref={(ref) => (this.closeButtonWrapper = ref)}
                      onKeyUp={
                        !hitEnterOnSearch
                          ? () => {}
                          : (e) => {
                              if (e.keyCode === 13) {
                                this.setState({ showSearch: true })
                              }
                            }
                      }
                    >
                      {this.renderCloseButton()}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    }
    return null
  }
}

// eslint-disable-next-line react-19-upgrade/no-prop-types
BottomHeader.propTypes = {
  navigationDetails: PropTypes.array.isRequired,
  languageRoute: PropTypes.string.isRequired,
  logo: PropTypes.string.isRequired,
  logoLink: PropTypes.string.isRequired,
  megaNavSelection: PropTypes.string.isRequired,
  onMegaNavSelection: PropTypes.func.isRequired,
  strings: PropTypes.object.isRequired,
  indexList: PropTypes.array.isRequired,
  logoAltText: PropTypes.string.isRequired,
  suggestionIndex: PropTypes.string.isRequired,
  queryIndex: PropTypes.string.isRequired,
  searchBarPlaceholderText: PropTypes.string.isRequired,
  numResults: PropTypes.number.isRequired,
  numHighlightedResults: PropTypes.number.isRequired,
  numberQueries: PropTypes.number.isRequired,
  numCharacters: PropTypes.number.isRequired,
  errorMessageTitle: PropTypes.string.isRequired,
  errorMessageDescription: PropTypes.string.isRequired,
  failureTitle: PropTypes.string.isRequired,
  failureDescription: PropTypes.string.isRequired,
  suggestedText: PropTypes.string.isRequired,
  resultsText: PropTypes.string.isRequired,
  seeAllResultsText: PropTypes.string.isRequired,
  searchDelay: PropTypes.number.isRequired,
  resultsIndex: PropTypes.string.isRequired,
  filterType: PropTypes.string.isRequired,
  closeMegaNav: PropTypes.func.isRequired,
  location: PropTypes.object,
}

// eslint-disable-next-line react-19-upgrade/no-default-props
BottomHeader.defaultProps = {
  location: {},
}

export default withLDConsumer()(withLocalization(strings)(BottomHeader))
